import Vue from 'vue';

const signalrModule = {
  namespaced: true,

  state: {
    isConnected: false,
  },

  actions: {
    connect({ commit }) {
      commit('connect', true);
    },
    disconnect({ commit }) {
      commit('disconnect', false);
    },
  },

  mutations: {
    connect(state) {
      Vue.set(state, 'isConnected', true);
    },
    disconnect(state) {
      Vue.set(state, 'isConnected', false);
    },
  },

  getters: {
    getSignalrConnectionStatus(state) {
      return state.isConnected;
    },
  },
};

export default signalrModule;
